// removed by extract-text-webpack-plugin
module.exports = {"root":"root_1W6aI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Option/style.css
// module id = 212
// module chunks = 0